import React from 'react'

export default function GraphicCalendarNote({colorType, position}){
    return <div className={['graphic-calendar-note', colorType, position].join(' ')}/>
}